import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import CouponService from '../../../services/CouponService';
import Results from './Results';
import Toolbar from './Toolbar';

import { selector as UserSelector } from '../../../redux/ducks/user';

const useStyles = makeStyles((theme) => ({
  categoryTitle: {
    display: 'inline-block',
    marginRight: '1rem'
  },
  titleEditable: {
    fontSize: '2.18rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    lineHeight: 1.167,
    letterSpacing: '-0.24px',
    color: '#888',
    marginBottom: '.5rem',
  },
  saveIcon: {
    color: 'white',
  },
  editButton: {
    cursor: 'pointer'
  },
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CouponView = () => {
  const classes = useStyles();
  const { user } = useSelector(UserSelector);
  const [coupons, setCoupons] = useState([]);

  const getCoupons = async () => {
    const response = await CouponService.getAll();

    if (response?.code === 200 && response?.data?.length > 0) {
      setCoupons(response?.data);
    }
  };

  const refresh = async () => {
    if (user?.id) {
      await getCoupons();
    }
  };

  useEffect(() => {
    if (user?.id) {
      getCoupons();
    }
  }, [user]);

  return (
    <Page
      className={classes.root}
      title="Cupones"
    >
      <Container maxWidth={false}>
        <Toolbar refresh={refresh} />
        <Box mt={3}>
          <Results data={coupons} onRefresh={refresh} />
        </Box>
      </Container>
    </Page>
  );
};

export default CouponView;
